module.exports = __webpack_public_path__ + "static/media/LOGO PEGADAIAN.3de18f6b.png";